<div class="card card-custom gutter-b" *ngIf="feedbackLoaded">

    <div class="card-header">
        <div class="card-title">
            <h3 class="card-label">
                <span>View Feedback</span>
            </h3>
        </div>
        <div class="card-toolbar">
            <app-general-button
                    [btnType]="'Short'"
                    [btnAction]="'Back'"
                    [btnStyle]="'Outline'"
                    routerLink="/feedback/list">
            </app-general-button>
        </div>
    </div>


    <div class="card-body p-0 m-0">
        <div class="col-lg-12 p-0 m-0 p-12">

            <!--Title-->
            <div class="section-wrapper">
                <div class="title title-color">
                    {{feedbackData.subject}}
                </div>
            </div>

            <!--Author & Date-->
            <div class="section-wrapper mt-3">
                <span class="font-weight-boldest mr-2 main-color">{{feedbackData.userName}}</span>
                <span class="mr-2"> - </span>
                <span class="mr-2">
                    <span translate="GENERAL.POSTED_AT"></span>
                    {{feedbackData.date + 'z' | date : 'dd-MM-yyyy hh:mm a'}}
                </span>
            </div>

            <!--Author & Date-->
            <div class="section-wrapper mt-3">
                <span class="font-weight-boldest mr-2 main-color">Sent from location</span>
                <span class="mr-2"> - </span>
                <a routerLink="{{feedbackData.linkURL}}" class="mr-2">
                    {{feedbackData.linkURL}}
                </a>
            </div>

            <!--Description-->
            <div class="col-lg-12 p-0 m-0 py-6 mt-3">
                <div class="pro-text" [innerHtml]="feedbackData.message"></div>
            </div>

        </div>
    </div>
</div>
